// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackToList_backButton__gT6WB"};